module.exports = __webpack_public_path__ + "static/img/frame.d7897c50.png";